import { connect } from 'react-redux';
import View from '../layouts/mainLayout';
// Actions
import { setSelectedCourse, updateUserInCognito } from '../actions/userActions';
import { signOutUser } from '../actions/loginActions';
import {
  switchCourse,
  getCourseData,
  setPercentageLoadingScreen,
  setSelectedTab
} from '../actions/courseActions';
import { setOpenDisabledCourseModal, setSubmitOpenDisableCourseModal } from '../actions/appActions';
import { handleCatchError, setNotification } from '../actions/errorHandlerActions';
import { startLoading } from '../actions/loaderHandlerActions';
// Selectors
import { getLoadingHandler } from '../selectors/loaderHandlerSelectors';
import { getCourseIdReducer, getStudentDataReducer } from '../selectors/userSelectors';
import {
  getCourseDataReducer,
  getAvailableCoursesReducer,
  getPercentageLoadingScreen,
  getLoadingScreen
} from '../selectors/Course/courseSelector';
import { getOpenDisabledModal, getSubmitOpenDisabledModal } from '../selectors/appSelectors';

const mapStateToProps = state => ({
  availableCourses: getAvailableCoursesReducer(state),
  courseData: getCourseDataReducer(state),
  loadingHadler: getLoadingHandler(state),
  loadingScreen: getLoadingScreen(state),
  openDisabledModal: getOpenDisabledModal(state),
  percentageLoadingScreen: getPercentageLoadingScreen(state),
  selectedCourseId: getCourseIdReducer(state),
  studentData: getStudentDataReducer(state),
  submitedOpenDisabledCourseModal: getSubmitOpenDisabledModal(state)
});

const mapDispatchToProps = dispatch => {
  return {
    getCourseData: payload => dispatch(getCourseData(payload)),
    handleCatchError: (error, message) => dispatch(handleCatchError(error, message)),
    setNotification: payload => dispatch(setNotification(payload)),
    setOpenDisabledCourseModal: payload => dispatch(setOpenDisabledCourseModal(payload)),
    setPercentageLoadingScreen: payload => dispatch(setPercentageLoadingScreen(payload)),
    setSelectedCourseAction: value => dispatch(setSelectedCourse(value)),
    setSubmitOpenDisableCourseModal: payload => dispatch(setSubmitOpenDisableCourseModal(payload)),
    setValueTab: value => dispatch(setSelectedTab(value)),
    signOutUser: value => dispatch(signOutUser(value)),
    startLoading: payload => dispatch(startLoading(payload)),
    switchCourse: value => dispatch(switchCourse(value)),
    updateUserInCognito: payload => dispatch(updateUserInCognito(payload))
  };
};

const Container = connect(mapStateToProps, mapDispatchToProps)(View);

export default Container;
